"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const animation_1 = require("./class/animation");
animation_1.Animation.init();
